export const initialForceEdit = {
    queue: [],
    index: 0,
    visible: false,
    edited: [],
    objectUrl: null,
}

/**
 * Reducer для управления очередью редактирования.
 * @param {typeof initialForceEdit} state
 * @param {{ type: string, [key:string]: any }} action
 */

export function forceImageEditReducer(state, action) {
    switch (action.type) {
        case 'START': {
            const files = action.files || [];
            if (state.objectUrl) URL.revokeObjectURL(state.objectUrl);

            return {
                queue: files,
                index:0,
                visible: !!files.length,
                edited: [],
                objectUrl: files.length ? URL.createObjectURL(files[0]) : null,
            }
        }

        case 'SAVE_CURRENT': {
            const nextEdited =  [...state.edited, action.file];
            const nextIndex = state.index + 1;

            if(nextIndex >= state.queue.length) {
                if (state.objectUrl) URL.revokeObjectURL(state.objectUrl);
                return {...initialForceEdit, edited: nextEdited};
            }

            if (state.objectUrl) URL.revokeObjectURL(state.objectUrl);
            return {
                ...state,
                edited: nextEdited,
                index: nextIndex,
                objectUrl: URL.createObjectURL(state.queue[nextIndex]),
            };
        }

        case 'CANCEL': {
            if (state.objectUrl) URL.revokeObjectURL(state.objectUrl);
            return {...initialForceEdit};
        }

        default:
            return state;
    }
}